
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus, Minus } from "lucide-react";

interface BallsStrikesControlProps {
  balls: number;
  strikes: number;
  onResetCount: () => void;
  onBallsChange: (balls: number) => void;
  onStrikesChange: (strikes: number) => void;
}

export function BallsStrikesControl({
  balls,
  strikes,
  onResetCount,
  onBallsChange,
  onStrikesChange,
}: BallsStrikesControlProps) {
  return (
    <div className="bg-white/5 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-lg sm:text-xl font-semibold text-white">Count</h4>
        <button 
          onClick={onResetCount}
          className="px-4 py-2 text-sm bg-white/10 hover:bg-white/20 text-white rounded transition-colors"
        >
          Reset
        </button>
      </div>
      <div className="space-y-3">
        <div className="flex items-center justify-between gap-2">
          <span className="text-sm sm:text-base text-white">Balls ({balls})</span>
          <div className="flex gap-2">
            <Button 
              onClick={() => onBallsChange(Math.max(0, balls - 1))}
              variant="outline"
              size="icon"
              className="border-white/20 h-10"
            >
              <Minus className="h-4 w-4" />
            </Button>
            <Button 
              onClick={() => onBallsChange(Math.min(3, balls + 1))}
              variant="outline"
              size="icon"
              className="border-white/20 h-10"
            >
              <Plus className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <div className="flex items-center justify-between gap-2">
          <span className="text-sm sm:text-base text-white">Strikes ({strikes})</span>
          <div className="flex gap-2">
            <Button 
              onClick={() => onStrikesChange(Math.max(0, strikes - 1))}
              variant="outline"
              size="icon"
              className="border-white/20 h-10"
            >
              <Minus className="h-4 w-4" />
            </Button>
            <Button 
              onClick={() => onStrikesChange(Math.min(3, strikes + 1))}
              variant="outline"
              size="icon"
              className="border-white/20 h-10"
            >
              <Plus className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
